import type { WidgetConfig } from "@/shared/lib/snippet";
import { useConfigurator } from "./configuratorContext";

export function useWidgetConfig(): WidgetConfig {
  const { colors, partnerId, b, chan, hidePromo, hideTitle, product, companies } =
    useConfigurator();
  return { colors, partnerId, b, chan, hidePromo, hideTitle, product, companies };
}
